import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-form ant-form-vertical" }
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_5 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_10 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "ENDEREÇOS", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"red","font-size":"14px"} }, "*", -1)
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_icone = _resolveComponent("icone")!
  const _component_dados_principais_pessoa = _resolveComponent("dados-principais-pessoa")!
  const _component_selecionar_relacao_pessoa = _resolveComponent("selecionar-relacao-pessoa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_marcador = _resolveComponent("selecionar-marcador")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_display_tela_personalizada = _resolveComponent("display-tela-personalizada")!
  const _component_card = _resolveComponent("card")!
  const _component_dados_colaborador = _resolveComponent("dados-colaborador")!
  const _component_enderecos_pessoa = _resolveComponent("enderecos-pessoa")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_dados_pessoais = _resolveComponent("dados-pessoais")!
  const _component_inscricoes_pessoa = _resolveComponent("inscricoes-pessoa")!
  const _component_fiscal_tributacao_pessoa = _resolveComponent("fiscal-tributacao-pessoa")!
  const _component_dados_financeiro_cliente = _resolveComponent("dados-financeiro-cliente")!
  const _component_dados_bancarios_pessoa = _resolveComponent("dados-bancarios-pessoa")!
  const _component_contatos_pessoa = _resolveComponent("contatos-pessoa")!
  const _component_anexos_pessoa = _resolveComponent("anexos-pessoa")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: "97%",
      "wrap-class-name": _ctx.state.windowWidth <= 1400 ? 'full-modal ss-modal-cadastros' : 'ss-modal-cadastros',
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      maskClosable: false
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.props.tituloModal) + " ", 1),
        _createVNode(_component_a_switch, {
          checked: _ctx.state.pessoa.ativo,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.pessoa.ativo) = $event)),
          style: {"float":"right"},
          "checked-children": "Ativo",
          "un-checked-children": "Inativo"
        }, null, 8, ["checked"]),
        _withDirectives(_createVNode(_component_a_checkbox, {
          style: {"float":"right"},
          checked: _ctx.state.pessoa.cliente.padraoFrenteCaixa,
          "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.pessoa.cliente.padraoFrenteCaixa) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Padrão Frente Caixa")
          ]),
          _: 1
        }, 8, ["checked"]), [
          [_vShow, _ctx.props.relacaoPrincipalOperacao === _ctx.ETipoRelacaoPessoa.Cliente]
        ])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir)
          || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.UtilitarioGeral.valorValido(_ctx.modalBase.textoBotaoSalvarNovo))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "ant-btn ant-btn-lg ant-btn-secondary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(true)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.salvar(false)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando,
          paragraph: { rows: 15 }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.state.exibirCamposPersonalizados)
                ? (_openBlock(), _createBlock(_component_display_tela_personalizada, {
                    key: 0,
                    codigoRegistro: _ctx.state.codigoPessoa,
                    personalizacao: _ctx.state.personalizacaoTela
                  }, {
                    AbaPrincipal: _withCtx(() => [
                      _createVNode(_component_dados_principais_pessoa, {
                        codigo: _ctx.state.pessoa.codigo,
                        "onUpdate:codigo": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.pessoa.codigo) = $event)),
                        tipoPessoa: _ctx.state.pessoa.tipoPessoa,
                        "onUpdate:tipoPessoa": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.pessoa.tipoPessoa) = $event)),
                        telefone: _ctx.state.pessoa.telefone,
                        "onUpdate:telefone": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.pessoa.telefone) = $event)),
                        site: _ctx.state.pessoa.site,
                        "onUpdate:site": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.pessoa.site) = $event)),
                        email: _ctx.state.pessoa.email,
                        "onUpdate:email": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.pessoa.email) = $event)),
                        cpf: _ctx.state.pessoa.pessoaFisica.cpf,
                        "onUpdate:cpf": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.cpf) = $event)),
                        nomeCompleto: _ctx.state.pessoa.pessoaFisica.nomeCompleto,
                        "onUpdate:nomeCompleto": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.nomeCompleto) = $event)),
                        nomeAbreviado: _ctx.state.pessoa.pessoaFisica.nomeAbreviado,
                        "onUpdate:nomeAbreviado": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.nomeAbreviado) = $event)),
                        cnpj: _ctx.state.pessoa.pessoaJuridica.cnpj,
                        "onUpdate:cnpj": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.pessoa.pessoaJuridica.cnpj) = $event)),
                        razaoSocial: _ctx.state.pessoa.pessoaJuridica.razaoSocial,
                        "onUpdate:razaoSocial": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.pessoa.pessoaJuridica.razaoSocial) = $event)),
                        nomeFantasia: _ctx.state.pessoa.pessoaJuridica.nomeFantasia,
                        "onUpdate:nomeFantasia": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.pessoa.pessoaJuridica.nomeFantasia) = $event)),
                        contato: _ctx.state.pessoa.pessoaJuridica.contato,
                        "onUpdate:contato": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.pessoa.pessoaJuridica.contato) = $event)),
                        tipoAtividade: _ctx.state.pessoa.fiscal.tipoAtividade,
                        "onUpdate:tipoAtividade": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.pessoa.fiscal.tipoAtividade) = $event)),
                        onAtualizarDadosConsultaCnpj: _ctx.atualizarDadosConsultaCnpj
                      }, null, 8, ["codigo", "tipoPessoa", "telefone", "site", "email", "cpf", "nomeCompleto", "nomeAbreviado", "cnpj", "razaoSocial", "nomeFantasia", "contato", "tipoAtividade", "onAtualizarDadosConsultaCnpj"]),
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_a_form_item, {
                            label: "Tipo de relação",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_relacao_pessoa, {
                                relacaoPrincipal: _ctx.props.relacaoPrincipalOperacao,
                                varias: true,
                                codigosSelecionados: _ctx.state.relacoesSelecionadas,
                                "onUpdate:codigosSelecionados": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.relacoesSelecionadas) = $event)),
                                onChange: _ctx.estrategiaAlteracaoRelacao
                              }, null, 8, ["relacaoPrincipal", "codigosSelecionados", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_a_form_item, {
                            label: "Marcadores",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_marcador, {
                                marcadoresSelecionados: _ctx.state.marcadoresSelecionados,
                                "onUpdate:marcadoresSelecionados": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.marcadoresSelecionados) = $event))
                              }, null, 8, ["marcadoresSelecionados"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_a_form_item, {
                            label: "Empresas",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_empresa, {
                                varias: true,
                                empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                                codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                                "onUpdate:codigosSelecionados": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
                              }, null, 8, ["empresasEspecificas", "codigosSelecionados"])
                            ]),
                            _: 1
                          })
                        ])
                      ], 512), [
                        [_vShow, _ctx.telaBase.apresentarEmpresas]
                      ])
                    ]),
                    _: 1
                  }, 8, ["codigoRegistro", "personalizacao"]))
                : (_openBlock(), _createBlock(_component_card, {
                    key: 1,
                    titulo: "DADOS PRINCIPAIS"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_dados_principais_pessoa, {
                        codigo: _ctx.state.pessoa.codigo,
                        "onUpdate:codigo": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.pessoa.codigo) = $event)),
                        tipoPessoa: _ctx.state.pessoa.tipoPessoa,
                        "onUpdate:tipoPessoa": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.pessoa.tipoPessoa) = $event)),
                        telefone: _ctx.state.pessoa.telefone,
                        "onUpdate:telefone": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.pessoa.telefone) = $event)),
                        site: _ctx.state.pessoa.site,
                        "onUpdate:site": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.pessoa.site) = $event)),
                        email: _ctx.state.pessoa.email,
                        "onUpdate:email": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.pessoa.email) = $event)),
                        cpf: _ctx.state.pessoa.pessoaFisica.cpf,
                        "onUpdate:cpf": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.cpf) = $event)),
                        nomeCompleto: _ctx.state.pessoa.pessoaFisica.nomeCompleto,
                        "onUpdate:nomeCompleto": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.nomeCompleto) = $event)),
                        nomeAbreviado: _ctx.state.pessoa.pessoaFisica.nomeAbreviado,
                        "onUpdate:nomeAbreviado": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.nomeAbreviado) = $event)),
                        cnpj: _ctx.state.pessoa.pessoaJuridica.cnpj,
                        "onUpdate:cnpj": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.pessoa.pessoaJuridica.cnpj) = $event)),
                        razaoSocial: _ctx.state.pessoa.pessoaJuridica.razaoSocial,
                        "onUpdate:razaoSocial": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.pessoa.pessoaJuridica.razaoSocial) = $event)),
                        nomeFantasia: _ctx.state.pessoa.pessoaJuridica.nomeFantasia,
                        "onUpdate:nomeFantasia": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.pessoa.pessoaJuridica.nomeFantasia) = $event)),
                        contato: _ctx.state.pessoa.pessoaJuridica.contato,
                        "onUpdate:contato": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.pessoa.pessoaJuridica.contato) = $event)),
                        tipoAtividade: _ctx.state.pessoa.fiscal.tipoAtividade,
                        "onUpdate:tipoAtividade": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.pessoa.fiscal.tipoAtividade) = $event)),
                        onAtualizarDadosConsultaCnpj: _ctx.atualizarDadosConsultaCnpj,
                        onBlurCpfCnpj: _ctx.verificarUsoCpf,
                        onBlurNome: _ctx.verificarUsoNome
                      }, null, 8, ["codigo", "tipoPessoa", "telefone", "site", "email", "cpf", "nomeCompleto", "nomeAbreviado", "cnpj", "razaoSocial", "nomeFantasia", "contato", "tipoAtividade", "onAtualizarDadosConsultaCnpj", "onBlurCpfCnpj", "onBlurNome"]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_a_form_item, {
                            label: "Tipo de relação",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_relacao_pessoa, {
                                relacaoPrincipal: _ctx.props.relacaoPrincipalOperacao,
                                varias: true,
                                codigosSelecionados: _ctx.state.relacoesSelecionadas,
                                "onUpdate:codigosSelecionados": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.relacoesSelecionadas) = $event)),
                                onChange: _ctx.estrategiaAlteracaoRelacao
                              }, null, 8, ["relacaoPrincipal", "codigosSelecionados", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_a_form_item, {
                            label: "Marcadores",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_marcador, {
                                marcadoresSelecionados: _ctx.state.marcadoresSelecionados,
                                "onUpdate:marcadoresSelecionados": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.marcadoresSelecionados) = $event))
                              }, null, 8, ["marcadoresSelecionados"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_a_form_item, {
                            label: "Empresas",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_empresa, {
                                varias: true,
                                empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                                codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                                "onUpdate:codigosSelecionados": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event)),
                                onChange: _ctx.estrategiaAlteracaoEmpresa
                              }, null, 8, ["empresasEspecificas", "codigosSelecionados", "onChange"])
                            ]),
                            _: 1
                          })
                        ])
                      ], 512), [
                        [_vShow, _ctx.telaBase.apresentarEmpresas]
                      ])
                    ]),
                    _: 1
                  })),
              (_ctx.verificaApresentacaoColaborador())
                ? (_openBlock(), _createBlock(_component_dados_colaborador, {
                    key: 2,
                    colaborador: _ctx.state.pessoa.colaborador,
                    "onUpdate:colaborador": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.pessoa.colaborador) = $event)),
                    funcoes: _ctx.state.funcoes,
                    "onUpdate:funcoes": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.funcoes) = $event)),
                    departamentos: _ctx.state.departamentos,
                    "onUpdate:departamentos": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.departamentos) = $event)),
                    comissoesCategorias: _ctx.state.comissoesCategorias,
                    "onUpdate:comissoesCategorias": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.comissoesCategorias) = $event)),
                    empresas: _ctx.telaBase.empresasSelecionadas
                  }, null, 8, ["colaborador", "funcoes", "departamentos", "comissoesCategorias", "empresas"]))
                : _createCommentVNode("", true),
              _createVNode(_component_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tabs, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tab_pane, { key: "1" }, {
                        tab: _withCtx(() => [
                          _hoisted_13,
                          _hoisted_14
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_enderecos_pessoa, {
                            enderecos: _ctx.state.pessoa.enderecos,
                            "onUpdate:enderecos": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.state.pessoa.enderecos) = $event)),
                            relacoes: _ctx.state.relacoesSelecionadas,
                            empresas: _ctx.telaBase.empresasSelecionadas
                          }, null, 8, ["enderecos", "relacoes", "empresas"])
                        ]),
                        _: 1
                      }),
                      (_ctx.state.pessoa.tipoPessoa === 1)
                        ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                            key: "2",
                            tab: "DADOS PESSOAIS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_dados_pessoais, {
                                empresas: _ctx.telaBase.empresasSelecionadas,
                                codigoCidadeNascimento: _ctx.state.pessoa.pessoaFisica.codigoCidadeNascimento,
                                "onUpdate:codigoCidadeNascimento": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.codigoCidadeNascimento) = $event)),
                                foto: _ctx.state.pessoa.pessoaFisica.foto,
                                "onUpdate:foto": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.foto) = $event)),
                                estadoCivil: _ctx.state.pessoa.pessoaFisica.estadoCivil,
                                "onUpdate:estadoCivil": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.estadoCivil) = $event)),
                                rg: _ctx.state.pessoa.pessoaFisica.rg,
                                "onUpdate:rg": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.rg) = $event)),
                                orgaoEmissor: _ctx.state.pessoa.pessoaFisica.orgaoEmissor,
                                "onUpdate:orgaoEmissor": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.orgaoEmissor) = $event)),
                                dataNascimento: _ctx.state.pessoa.pessoaFisica.dataNascimento,
                                "onUpdate:dataNascimento": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.dataNascimento) = $event)),
                                nomePai: _ctx.state.pessoa.pessoaFisica.nomePai,
                                "onUpdate:nomePai": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.nomePai) = $event)),
                                nomeMae: _ctx.state.pessoa.pessoaFisica.nomeMae,
                                "onUpdate:nomeMae": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.nomeMae) = $event)),
                                cnh: _ctx.state.pessoa.pessoaFisica.cnh,
                                "onUpdate:cnh": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.cnh) = $event)),
                                categoriaCnh: _ctx.state.pessoa.pessoaFisica.categoriaCnh,
                                "onUpdate:categoriaCnh": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.categoriaCnh) = $event)),
                                dataVencimentoCnh: _ctx.state.pessoa.pessoaFisica.dataVencimentoCnh,
                                "onUpdate:dataVencimentoCnh": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.state.pessoa.pessoaFisica.dataVencimentoCnh) = $event)),
                                tipoAtividade: _ctx.state.pessoa.fiscal.tipoAtividade,
                                "onUpdate:tipoAtividade": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.state.pessoa.fiscal.tipoAtividade) = $event))
                              }, null, 8, ["empresas", "codigoCidadeNascimento", "foto", "estadoCivil", "rg", "orgaoEmissor", "dataNascimento", "nomePai", "nomeMae", "cnh", "categoriaCnh", "dataVencimentoCnh", "tipoAtividade"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.verificaApresentacaoFiscalInscricoes())
                        ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                            key: "3",
                            tab: "INSCRIÇÕES"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_inscricoes_pessoa, {
                                inscricoes: _ctx.state.pessoa.inscricoes,
                                "onUpdate:inscricoes": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.state.pessoa.inscricoes) = $event)),
                                relacoes: _ctx.state.relacoesSelecionadas,
                                empresas: _ctx.telaBase.empresasSelecionadas
                              }, null, 8, ["inscricoes", "relacoes", "empresas"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.verificaApresentacaoFiscalInscricoes())
                        ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                            key: "4",
                            tab: "FISCAL/TRIBUTAÇÃO"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_fiscal_tributacao_pessoa, {
                                tipoPessoa: _ctx.state.pessoa.tipoPessoa,
                                fiscal: _ctx.state.pessoa.fiscal,
                                "onUpdate:fiscal": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.state.pessoa.fiscal) = $event))
                              }, null, 8, ["tipoPessoa", "fiscal"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.verificaApresentacaoFiscalInscricoes())
                        ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                            key: "5",
                            tab: "DADOS FINANCEIROS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_dados_financeiro_cliente, {
                                empresas: _ctx.telaBase.empresasSelecionadas,
                                financeiro: _ctx.state.pessoa.cliente.financeiro,
                                "onUpdate:financeiro": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.state.pessoa.cliente.financeiro) = $event)),
                                "tipos-documentos": _ctx.state.tiposDocumentos,
                                "onUpdate:tiposDocumentos": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.state.tiposDocumentos) = $event))
                              }, null, 8, ["empresas", "financeiro", "tipos-documentos"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_tab_pane, {
                        key: "7",
                        tab: "DADOS BANCÁRIOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_dados_bancarios_pessoa, {
                            dadosBancarios: _ctx.state.pessoa.dadosBancarios,
                            "onUpdate:dadosBancarios": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.state.pessoa.dadosBancarios) = $event))
                          }, null, 8, ["dadosBancarios"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "8",
                        tab: "CONTATOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_contatos_pessoa, {
                            contatos: _ctx.state.pessoa.contatos,
                            "onUpdate:contatos": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.state.pessoa.contatos) = $event)),
                            relacoes: _ctx.state.relacoesSelecionadas,
                            empresas: _ctx.telaBase.empresasSelecionadas
                          }, null, 8, ["contatos", "relacoes", "empresas"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "9",
                        tab: "ANEXOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_anexos_pessoa, {
                            anexos: _ctx.state.pessoa.anexos,
                            "onUpdate:anexos": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.state.pessoa.anexos) = $event))
                          }, null, 8, ["anexos"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "10",
                        tab: "OBSERVAÇÕES"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_editor_html, {
                                value: _ctx.state.pessoa.observacoes,
                                "onUpdate:value": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.state.pessoa.observacoes) = $event))
                              }, null, 8, ["value"])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["wrap-class-name", "visible"])
  ]))
}